import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { Loader2, ArrowLeft, ShieldCheck } from "lucide-react";

export default function Legal() {
  const { docKey } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/legal/docs")
      .then((r) => setDoc(r.data.docs[docKey] || null))
      .catch(() => setDoc(null))
      .finally(() => setLoading(false));
  }, [docKey]);

  return (
    <div className="min-h-screen bg-background">
      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-10">
        <Link to="/dashboard" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-6" data-testid="legal-back">
          <ArrowLeft className="h-4 w-4" /> Back
        </Link>
        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>
        ) : !doc ? (
          <p className="text-muted-foreground">Document not found.</p>
        ) : (
          <div data-testid={`legal-doc-${docKey}`}>
            <div className="flex items-center gap-2 mb-2">
              <ShieldCheck className="h-5 w-5 text-primary" />
              <span className="text-[11px] font-mono uppercase tracking-[0.3em] text-primary">DronAcademy</span>
            </div>
            <h1 className="font-display text-3xl font-bold">{doc.title}</h1>
            <p className="text-xs font-mono text-muted-foreground mt-1 mb-6">Version {doc.version}</p>
            <div className="prose-content text-[15px] text-slate-300 leading-relaxed whitespace-pre-line"
              dangerouslySetInnerHTML={{
                __html: (doc.content || "").replace(/&/g, "&amp;").replace(/</g, "&lt;")
                  .replace(/\*\*(.+?)\*\*/g, '<strong class="text-foreground">$1</strong>'),
              }} />
          </div>
        )}
      </main>
    </div>
  );
}
